module.exports = __webpack_public_path__ + "static/media/AudienceLocation-en.58987380.jpg";